module.exports = __webpack_public_path__ + "static/media/download.9609f2e5.svg";